module.exports = __webpack_public_path__ + "static/media/hero-banner-mobile.662fde8e.png";